/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Ui_Weather_Wind_Mostly_TailInputs */

const en_ui_weather_wind_mostly_tail = /** @type {(inputs: Ui_Weather_Wind_Mostly_TailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wind ${i?.range} · mostly tailwind`)
};

const de_ui_weather_wind_mostly_tail = /** @type {(inputs: Ui_Weather_Wind_Mostly_TailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wind ${i?.range} · meist Rückenwind`)
};

/**
* | output |
* | --- |
* | "Wind {range} · mostly tailwind" |
*
* @param {Ui_Weather_Wind_Mostly_TailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_wind_mostly_tail = /** @type {((inputs: Ui_Weather_Wind_Mostly_TailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Wind_Mostly_TailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_wind_mostly_tail(inputs)
	return de_ui_weather_wind_mostly_tail(inputs)
});